module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/queen.457cf67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/queen.jpg
// module id = ff1V
// module chunks = 0